module.exports = __webpack_public_path__ + "media/images/plans/ceremony/estimate_3-ea6d6f5a275eaf980c0c0f21c8c5620d.jpg";